export const ClockCircle = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_128_4201)">
        <path
          d="M6 0.75C3.10078 0.75 0.75 3.10078 0.75 6C0.75 8.89922 3.10078 11.25 6 11.25C8.89922 11.25 11.25 8.89922 11.25 6C11.25 3.10078 8.89922 0.75 6 0.75ZM6 10.3594C3.59297 10.3594 1.64062 8.40703 1.64062 6C1.64062 3.59297 3.59297 1.64062 6 1.64062C8.40703 1.64062 10.3594 3.59297 10.3594 6C10.3594 8.40703 8.40703 10.3594 6 10.3594Z"
          fill="currentColor"
        />
        <path
          d="M8.04727 7.48359L6.37617 6.27539V3.375C6.37617 3.32344 6.33398 3.28125 6.28242 3.28125H5.71875C5.66719 3.28125 5.625 3.32344 5.625 3.375V6.60234C5.625 6.63281 5.63906 6.66094 5.66367 6.67852L7.60195 8.0918C7.64414 8.12227 7.70273 8.11289 7.7332 8.07187L8.06836 7.61484C8.09883 7.57148 8.08945 7.51289 8.04727 7.48359Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_128_4201">
          <rect width="12" height="12" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
